import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

import { UIService } from './../../../core/services/utils/ui.service';
import { TagService } from '../../../core/services/http-services/tag.service';
import { TagViewModel } from './../../../core/models/view-models/tag-models/tag-view.model';
import { LibraryEditItemTypeEnum } from './../../../core/enums/library-edit-item-type.enum';
import { DeleteDialogService } from './../../../core/services/dialog-services/delete-dialog.service';
import { ScreensStateService } from '../../../core/services/screen-state/screens-state.service';
import { AuthService } from '../../../core/services/auth/auth.service';
import { DisplayAccountViewModel } from '../../../core/models/view-models/account-models/user-models/display-account-view-model.type';
import { MonitorTagDialogMessagesEnum } from '../../../core/enums/toastr-messages/monitor-tag-dialog-messages.enum';
import { ScheduleDialogMessagesEnum } from '../../../core/enums/toastr-messages/schedule-dialog-messages.enum';

@Component({
  selector: 'app-tag-item',
  templateUrl: './tag-item.component.html',
  styleUrls: ['./tag-item.component.scss'],
})
export class TagItemComponent implements OnDestroy, OnInit {
  @Input() tag: TagViewModel;

  public userId: string;
  public isHover: boolean = false;
  public isActive: boolean = false;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private readonly uiService: UIService,
    private readonly tagService: TagService,
    public toastr: ToastrService,
    public deleteDialogService: DeleteDialogService,
    public readonly screensStateService: ScreensStateService,
    private readonly authService: AuthService
  ) {
    if (this.authService.userId) {
      this.userId = authService.userId;
    } else {
      this.subscriptions.add(this.authService.getCaller().subscribe((accountModel: DisplayAccountViewModel) => {
        this.userId = accountModel.Id;
      }));
    }
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.screensStateService.activeMonitorTagsChanged.subscribe(
        (activeTags: TagViewModel[]) => {
          this.isActive = _.some(activeTags, (x: TagViewModel) => this.tag && x && x.Id === this.tag.Id);
        }
      )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  removeTag(): void {
    this.subscriptions.add(
      this.deleteDialogService
        .show(MonitorTagDialogMessagesEnum.ConfirmDeleteTitle)
        .subscribe((isToDelete: boolean) => {
          if (isToDelete) {
            this.subscriptions.add(
              this.tagService.deleteTag(this.tag.Id).subscribe(() => {
                this.toastr.success(
                  `'${this.tag.Title}' ${ScheduleDialogMessagesEnum.DeleteScheduleSuccess}`,
                  MonitorTagDialogMessagesEnum.DeleteMonitorTagTitle
                );
                _.remove(this.tagService.tagCollectionChanged.value, (tag: TagViewModel) => tag.Id === this.tag.Id);
                this.tagService.tagCollectionChanged.next(this.tagService.tagCollectionChanged.value);
                this.screensStateService.tagItemChanged(this.tag, true);
              })
            );
          }
        })
    );
  }

  editTag(): void {
    this.screensStateService.monitorTagChanged.next(null);
    this.screensStateService.activeMonitorTagsChanged.next([]);
    const data = _.cloneDeep(this.tag);
    this.uiService.showLibraryEditPanel(data, LibraryEditItemTypeEnum.EditTag);
  }
}
